<!-- app.component.html -->
<div class="w-full">

    <!-- Header -->
    <div class="relative flex-0  min-h-28 overflow-hidden bg-primary flex">
    </div>

    <div class="flex justify-center">
        <div class="w-2/3">
            <!-- Header Section -->
            <div
                class="w-full bg-gray-300 text-center py-4 mt-6 text-sm font-bold rounded-full text-gray-800 flex items-center justify-center gap-2">
                <mat-icon svgIcon="heroicons_outline:folder-add" class="mr-1"></mat-icon>
                Créer un nouveau projet
            </div>


            <!-- Paragraph Section -->
            <div class="w-full p-4 mt-4 text-gray-800 rounded shadow no-document">
                <div class="font-bold text-md">Commencez votre projet en déposant le devis</div>
                <p class="mt-2 text-md">
                    Une fois validé par nos équipes, vous pourrez démarrer les travaux et ajouter tous les autres
                    documents
                    de
                    fin de travaux en une fois (facture, attestation sur l’honneur, rapport COFRAC, etc.).

                </p>
                <div class="mt-2 text-md">Si vous rencontrez un problème, n’hésitez pas à contacter votre Account
                    Manager.
                </div>
                <div class="mt-2 text-md">L’équipe ACE Energie</div>
            </div>

            <div class="w-full flex flex-wrap justify-center gap-4 items-start mt-3" *ngIf="selectedMandataire">
                <mat-form-field appearance="fill" class="w-72">
                    <mat-label class="mb-2">Nom du partenaire</mat-label>
                    <mat-select preventSpaceSelect [formControl]="partnersCtrl"
                        (selectionChange)="onPartnerSelected($event)">
                        <input class="p-2 setOrderMinusOne" matInput placeholder="Rechercher..." #selectPartner>
                        <mat-option *ngFor="let partner of partnersList | filterEntities: selectPartner?.value ?? ''"
                            [value]="partner">
                            {{partner.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <!-- personal information -->
            <div #informations class="flex flex-auto w-full mt-6">
                <ng-container>
                    <div class="flex flex-col font-['Bitter'] font-semibold text-lg text-left w-[200px]">
                        <h3 class="text-2xl">Informations</h3>
                        <h3 class="text-2xl">du projet</h3>
                    </div>
                    <div class="flex flex-col section-form">
                        <form [formGroup]="projectForm"
                            class="bg-neutral-50 rounded-xl shadow-md w-full mx-auto px-6 py-2">
                            <p class="mb-8 text-md text-gray-600">
                                Ces informations sont facultatives, mais elles facilitent le suivi et l'identification
                                de
                                votre
                                projet, et seront vérifiées lors de son traitement.
                            </p>

                            <!-- Row 1: 3 cols -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <mat-form-field appearance="fill">
                                    <mat-label>Raison sociale du bénéficiaire</mat-label>
                                    <input matInput formControlName="rs" />
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>Nom du bénéficiaire</mat-label>
                                    <input matInput formControlName="nom" />
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>Prénom du bénéficiaire</mat-label>
                                    <input matInput formControlName="prenom" />
                                </mat-form-field>
                            </div>

                            <!-- Row 2: 3 cols -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                                <mat-form-field appearance="fill">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" />
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>Date prévisionnelle de fin des travaux</mat-label>
                                    <input matInput [matDatepicker]="picker"
                                        formControlName="dateTravauxPrevisionnelle" />
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>Date d’engagement</mat-label>
                                    <input matInput [matDatepicker]="picker1" formControlName="dateEngagement" />
                                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                    <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="grid grid-cols-1 md:grid-cols-1 gap-6 mt-6">
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Adresse postale</mat-label>
                                    <input formControlName="adresse" readonly id="app-building-address"
                                        [matTooltip]="projectForm.get('adresse')?.value" matInput
                                        [matAutocomplete]="auto" (click)="showAdressAutocomplete()"
                                        (keydown.enter)="$event.preventDefault()">
                                    <button matSuffix mat-flat-button aria-label="search"
                                        class="-mr-3 bg-accent text-white pe" [matTooltip]="'Renseigner l\'adresse'"
                                        (click)="showAdressAutocomplete()" tabindex="-1">
                                        <mat-icon svgIcon="search"> </mat-icon></button>
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedOption($event)">
                                        <mat-option *ngFor="let option of filteredOptions?.features" [value]="option">
                                            {{option.properties.label}}, France </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>

                            <!-- Row 4: 1 col -->
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Code postal</mat-label>
                                    <input matInput formControlName="cp" />
                                </mat-form-field>
                                <mat-form-field appearance="fill" class="w-full">
                                    <mat-label>Ville</mat-label>
                                    <input matInput formControlName="ville" />
                                </mat-form-field>
                                <mat-form-field appearance="fill">
                                    <mat-label>Téléphone</mat-label>
                                    <input matInput formControlName="tel" />
                                </mat-form-field>
                            </div>
                        </form>
                    </div>
                </ng-container>
            </div>
            <div #documents class="flex flex-auto w-full mt-6 mb-2">
                <ng-container>
                    <div class="flex flex-col font-['Bitter'] font-semibold text-lg text-left w-[200px]">
                        <h3 class="text-2xl">Documents</h3>
                    </div>
                    <div class="flex flex-col section-form">
                        <!-- Cards Upload Section -->
                        <div class="w-full flex flex-wrap justify-center gap-4 items-start">
                            <div class="w-40 " *ngFor="let card of cards">

                                <!-- Drop zone -->
                                <app-card-upload [card]="card" (viewFile)="onViewFile($event)"
                                    (fileSelected)="onFileSelected($event)">
                                </app-card-upload>

                            </div>
                        </div>

                        <!-- Cards display Section -->
                        <div class="w-full flex flex-wrap justify-center gap-4 items-start">
                            <div
                                class="w-full flex flex-wrap justify-center gap-4 items-start max-h-[410px] overflow-auto py-2">

                                <!-- Single file cards (up to 3) -->
                                <ng-container *ngIf="getSingleFileCard().length > 0">
                                    <app-file-card *ngFor="let file of getSingleFileCard(); let i = index"
                                        [cardName]="file.card" [file]="file.files[0]" [fileName]="file.files[0].name"
                                        (fileDeleted)="onFileDeleted($event)"></app-file-card>
                                </ng-container>

                                <!-- Multi-file card (4th card slot) -->
                                <ng-container *ngIf="getMultipleFileCard().length > 0">
                                    <ng-container *ngFor="let file of getMultipleFileCard()[0].files; let i = index">
                                        <app-file-card
                                            [cardName]="'Autres justificatifs (CDC, Etude de dimensionnement, etc.)'"
                                            [fileName]="file.name" [file]="file"
                                            (fileDeleted)="onFileDeleted($event)"></app-file-card>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div #actionButtons class="flex flex-auto w-full mt-6">
                <ng-container>
                    <div class="flex flex-col font-['Bitter'] font-semibold text-lg text-left w-[200px]">
                    </div>
                    <div class="flex flex-col section-form">
                        <!-- Validation Button -->
                        <div class="w-full flex justify-center p-6">
                            <button (click)="deposeProjectFinancement()"
                                class="bg-accent text-white font-bold py-2 px-6 rounded shadow" mat-flat-button
                                aria-label="Déposer les documents"
                                [disabled]="isUploadDisabled() || isUploading || (selectedMandataire && !selectedPartnerByMandate)">
                                <mat-icon svgIcon="send" class="mr-1"></mat-icon>
                                Créer le projet
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>